import Vue from "vue";
import Vuex from "vuex";
import {
  Message
} from 'element-ui';

import students from "./modules/students";
import teachers from "./modules/teachers";
// 全局广播

import login from "@/api/login.js";
import types from "@/constants/types";
import states from "@/constants/state.js";
import router from '@/router/index.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    students,
    teachers
  },
  state: states.rootState,
  getters: {
    examStatus(state, getters, rootState) {
      if (state.questionList && state.questionList[0]) {
        return state.questionList[0].examStatus;
      }
    },
    leftTimes(state, getters, rootState) { // 剩余时间
      return state.leftTimes;
    },
    selfTrainingList(state, getters, rootState) {
      let list = state.selfTrainingList;
      if (list) {
        for (const i of list) {
          if (i.DoQuestionCount == 0 || i.TotalQuestionCount == 0) {
            i.CorrectPercent = 0;
          } else {
            i.CorrectPercent = Math.round(
              (i.DoQuestionCount / i.TotalQuestionCount) * 100
            );
          }
        }
      }
      return list;
    },
    questionList(state, getters, rootState) {
      return state.questionList;
    },
    getExamBasicInfoView(state, getters, rootState) {
      return state.examBasicInfoView;
    },
    simulatedTrainingList(state, getters, rootState) {
      return state.simulatedTrainingList;
    },
    getExamPaperGroupListByPage(state, getters, rootState) {
      return state.getExamPaperGroupListByPage;
    },
    getExamPaperPositions(state, getters, rootState) {
      return state.getExamPaperPositions.Data;
    },
    getobjectlist(state, getters, rootState) {
      return state.getobjectlist;
    },
    getcertificatesummerdatalist(state, getters, rootState) {
      return state.getcertificatesummerdatalist;
    },
    getsubjectbytype(state, getters, rootState) {
      return state.getsubjectbytype;
    },
    getcertificatedetaildatalist(state, getters, rootState) {
      return state.getcertificatedetaildatalist;
    },
    getcertificatebalancedatalist(state, getters, rootState) {
      return state.getcertificatebalancedatalist;
    },
    getstudentlastgrade(state, getters, rootState) {
      let arr = [];
      arr.push(state.getstudentlastgrade);
      return arr;
    },
    geterrorquestionlist(state, getters, rootState) {
      let arr = [];
      arr.push(state.geterrorquestionlist);
      return arr;
    },
    getstudentgradelist(state, getters, rootState) {
      return state.getstudentgradelist;
    },
    getteamgradelist(state, getters, rootState) {
      return state.getteamgradelist;
    },
    getteamlastgrade(state, getters, rootState) {
      let arr = [];
      arr.push(state.getteamlastgrade);
      return arr;
    },
    simulatedTopicInfo(state, getters, rootState) {
      return state.simulatedTopicInfo;
    },
    chathistorylist(state, getters, rootState) {
      // console.log(state.chathistorylist[0]);
      let newarr = [].concat(state.chathistorylist);
      if (newarr.length != 0) {
        for (let i = newarr.length; i--;) {
          newarr[i] = JSON.parse(newarr[i]);
        }
      }
      // console.log(newarr);
      return newarr.reverse();
    },
    chatStorylist(state, getters, rootState) {
      // console.log(state.chatStorylist);
      let nerarr = [].concat(state.chatStorylist);
      for (let i = nerarr.length; i--;) {
        if (!nerarr[i]) {
          nerarr.splice(i, 1);
        }
      }
      return nerarr;
    },
    getexamschoolcompetitiontasklist(state, getters, rootState) {
      return state.getexamschoolcompetitiontasklist;
    },
    getavailablecaselist(state, getters, rootState) {
      return state.getavailablecaselist;
    },
    deleteexamschoolcompetitiontask(state, getters, rootState) {
      return state.deleteexamschoolcompetitiontask;
    },
    publishschoolcompetitiontask(state, getters, rootState) {
      return state.publishschoolcompetitiontask;
    },
    papercenterlistbypage(state, getters, rootState) {
      return state.papercenterlistbypage;
    },
    // 实时监控-团队
    getcompetitionmonitor(state, getters, rootState) {
      // console.log(state.getcompetitionmonitor)
      return state.getcompetitionmonitor;
    },
    // 实时监控-个人
    getindividualcompetitionmonitor(state, getters, rootState) {
      // console.log(state.getindividualcompetitionmonitor)
      return state.getindividualcompetitionmonitor;
    },
    //总分排名
    getcompetitionrank(state, getters, rootState) {
      // console.log(state.getcompetitionrank)
      return state.getcompetitionrank;
    },
    //成绩明细
    getcompetitiondetailrank(state, getters, rootState) {
      // console.log(state.getcompetitiondetailrank)
      return state.getcompetitiondetailrank;
    },
    //总分排名-个人
    getindividualcompetitionrank(state, getters, rootState) {
      // console.log(state.getindividualcompetitionrank)
      return state.getindividualcompetitionrank;
    },
    //成绩明细-个人
    getindividualcompetitiondetailrank(state, getters, rootState) {
      // console.log(state.getindividualcompetitiondetailrank)
      return state.getindividualcompetitiondetailrank;
    },
    //路由信息
    routermess(state, getters, rootState) {
      return state.routermess;
    },
    //新增/修改申请订单
    savecaseapply(state, getters, rootState) {
      // console.log(state.savecaseapply)
      return state.savecaseapply;
    },
    //教师 自主分析-错题分析
    practiceerroranalysis(state, getters, rootState) {
      // console.log(state.practiceerroranalysis)
      return state.practiceerroranalysis;
    },
    //获取校园赛可购买案例
    getshoolcompetitioncaselist(state, getters, rootState) {
      // console.log(state.getshoolcompetitioncaselist)
      return state.getshoolcompetitioncaselist;
    },
    //自主分析 - 个人练习分析
    practicepersonalanalysis(state, getters, rootState) {
      // console.log(state.practicepersonalanalysis)
      return state.practicepersonalanalysis;
    },
    //自主分析 - 个人练习分析 - 明细
    practicepersonaldetail(state, getters, rootState) {
      // console.log(state.practicepersonaldetail)
      return state.practicepersonaldetail;
    },
    //模拟分析 - 团队练习分析
    emulationteamanalysis(state, getters, rootState) {
      // console.log(state.emulationpersonalanalysis)
      return state.emulationteamanalysis;
    },
    // -模拟分析 - 团队练习分析 - 明细
    emulationteamanalysisdetail(state, getters, rootState) {
      // console.log(state.emulationteamanalysisdetail)
      return state.emulationteamanalysisdetail;
    },
    // -模拟分析 错题分析
    examerroranalysisdetail(state, getters, rootState) {
      // console.log(state.examerroranalysisdetail)
      return state.examerroranalysisdetail;
    },
    //自主分析 - 个人练习分析 - 明细
    emulationpersonalanalysisdetail(state, getters, rootState) {
      // console.log(state.emulationpersonalanalysisdetail)
      return state.emulationpersonalanalysisdetail;
    },
    //自主分析 - 个人练习分析 - 岗位信息
    getexampaperpostions(state, getters, rootState) {
      // console.log(state.getexampaperpostions)
      return state.getexampaperpostions;
    },
    //自主分析 - 个人练习分析 - 折线图
    emulationpersonalanalysis(state, getters, rootState) {
      // console.log(state.emulationpersonalanalysis)
      return state.emulationpersonalanalysis;
    },
    //用户绑定信息
    userBindInfo(state, getters, rootState) {
      // console.log(state,228);
      return state.userBindInfo;
    },
    userInfo(state, getters, rootState) {
      return state.userInfo;
    },
  },
  mutations: {
    // 保存剩余时间
    leftTimes(state, value) {
      state.leftTimes = value;
    },
    //路由信息
    [types.ROUTERMESS](state, value) {
      state.routermess = value;
    },
    [types.USERINFO](state, value) {
      state.userInfo = value;
      sessionStorage.setItem('userInfo', JSON.stringify(value))
    },
    //用户绑定信息
    [types.USERBINDINFO](state, value) {
      state.userBindInfo = value;
      sessionStorage.setItem('userBindInfo', JSON.stringify(value))
    },
    [types.LOGINOUT](state, value) {
      state.userInfo = {};
      state.userBindInfo = {};
      sessionStorage.removeItem('userInfo');
      sessionStorage.removeItem('userBindInfo');
      localStorage.removeItem('resourseCategory')
    },
    //题目列表下标
    [types.TOPICLISTINDEX](state, value) {
      state.topicListIndex = value;
    },
    //题目加载状态
    [types.TOPICLOADED](state, value) {
      state.topicLoaded = value;
    },
    // 自主训练列表
    [types.SELFTRANININGLIST](state, value) {
      // console.log(value.Data)
      if (value.Data) {
        for (const i of value.Data) {
          i.Count = value.Count;
        }
      }
      state.selfTrainingList = value.Data;
    },
    // 自主训练题目列表
    [types.TOPIC_LIST](state, value) {
      if (value.Data && value.Data.QuestionInfoList) {
        let list = value.Data.QuestionInfoList;
        let gradeId = value.Data.GradeId;
        let examid = value.Data.ExamId;
        let company = value.Data.EnterpriseInfo;
        let rollUpType = value.Data.RollUpType;
        let examPaperGroupStudents = value.Data.ExamPaperGroupStudents;

        let answerStatus = {
          right: 0,
          rightPosArr: [],
          error: 0,
          errorPosArr: [],
          answered: 0,
          answeredPosArr: [],
          noanswer: 0,
          noanswerPosArr: []
        };
        let leftTime = 0;
        let titleTime = 0;
        let examStatus = 0;
        if (examPaperGroupStudents) {
          let targetStudents = examPaperGroupStudents.find(student => {
            return student.IsSelf
          })
          if (!targetStudents) return
          leftTime = targetStudents.LeftSeconds;
          titleTime = targetStudents.UsedSeconds;
          examStatus = targetStudents.StudentExamStatus;
        } else {
          leftTime = value.Data.LeftSeconds;
          titleTime = value.Data.UsedSeconds;
          examStatus = value.Data.StudentExamStatus;
        }

        for (const i of list) {

          i.examid = examid;
          i.gradeId = gradeId;
          i.leftTime = leftTime;
          i.titleTime = titleTime;
          i.RollUpType = rollUpType;
          i.PositionNameF = i.PositionName.substring(0, 1).replace("大", "数");

          if (i.Title && i.Title.length > 10) {
            i.subTitle = i.Title.substr(0, 10) + "...";
          } else {
            i.subTitle = i.Title;
          }
          if (i.QuestionAnswerStatus == 0) {
            answerStatus.noanswer++;
            answerStatus.noanswerPosArr.push(i.PositionId)
          } else {
            answerStatus.answered++;
            answerStatus.answeredPosArr.push(i.PositionId)
            if (i.QuestionAnswerStatus == 2) {
              answerStatus.right++;
              answerStatus.rightPosArr.push(i.PositionId)
            } else if (
              i.QuestionAnswerStatus == 3 ||
              i.QuestionAnswerStatus == 4
            ) {
              answerStatus.error++;
              answerStatus.errorPosArr.push(i.PositionId)
            }
          }
        }
        // 岗位列表
        let PositionIdArr = [];
        let roleList = [];
        list.map(i => {
          if (PositionIdArr.indexOf(i.PositionId) > -1) return;
          PositionIdArr.push(i.PositionId);
          roleList.push({
            PositionId: i.PositionId,
            PositionName: i.PositionName
          });
        });
        roleList.map(roleItem => {
          let posId = roleItem.PositionId;
          let Count = 0;
          list.filter(listItem => {
            if (listItem.PositionId === posId) Count++;
          });
          roleItem.Count = Count;
          return roleItem;
        });
        roleList.unshift({
          PositionId: 0,
          PositionName: "全部角色",
          Count: list.length
        });

        //附加试卷基本信息
        list[0].company = company;
        list[0].roleList = roleList;
        list[0].examStatus = examStatus;
        list[0].answerStatus = answerStatus;
        list[0].examPaperGroupStudents = examPaperGroupStudents;

        state.questionList = list;
      }
    },
    //修改题目列表-题目状态
    [types.TOPIC_ANS_STATUS](state, {
      status,
      examStatus,
      QuestionId,
      auditQuestionId,
      auditStatusArr,
      PostionName,
      showTips,
      oprQuesId
    }) {
      if (state.questionList) {
        if (examStatus != undefined) {
          state.questionList[0].examStatus = examStatus;
        }
        if (status != undefined && QuestionId != undefined) {
          state.questionList.map(value => {
            if (value.QuestionId == QuestionId) {
              let prevStatus = value.QuestionAnswerStatus;
              let newStatus = status;
              let answerStatus = state.questionList[0].answerStatus;
              if (newStatus == 0) {
                answerStatus.noanswer++;
                answerStatus.noanswerPosArr.push(value.PositionId);
              } else {
                answerStatus.answered++;
                answerStatus.answeredPosArr.push(value.PositionId);
                if (newStatus == 2) {
                  answerStatus.right++;
                  answerStatus.rightPosArr.push(value.PositionId);
                } else {
                  answerStatus.error++;
                  answerStatus.errorPosArr.push(value.PositionId);
                }
              }
              if (prevStatus == 0) {
                answerStatus.noanswer--;
                let idx = answerStatus.noanswerPosArr.indexOf(value.PositionId);
                answerStatus.noanswerPosArr.splice(idx, 1);
              } else {
                answerStatus.answered--;
                let idx = answerStatus.answeredPosArr.indexOf(value.PositionId);
                answerStatus.answeredPosArr.splice(idx, 1);
                if (prevStatus == 2) {
                  answerStatus.right--;
                  let idx = answerStatus.rightPosArr.indexOf(value.PositionId);
                  answerStatus.rightPosArr.splice(idx, 1);
                } else {
                  answerStatus.error--;
                  let idx = answerStatus.errorPosArr.indexOf(value.PositionId);
                  answerStatus.errorPosArr.splice(idx, 1);
                }
              }
              value.QuestionAnswerStatus = status;
            }
          });
        }
        if (status == undefined && QuestionId != undefined) {
          let item = state.questionList.find(item => {
            return item.QuestionId == QuestionId;
          });
          console.log(item)
          if (!item) return;
          item.IsMark = !item.IsMark;
          let markArr = sessionStorage.getItem('markArr');
          markArr = markArr ? JSON.parse(markArr) : [];
          let markArrItem = item.QuestionId + '|' + item.examid;
          let idx = markArr.indexOf(markArrItem);
          idx == -1 ? markArr.push(markArrItem) : markArr.splice(idx, 1);
          sessionStorage.setItem('markArr', JSON.stringify(markArr));
        }
        if (auditStatusArr != undefined && auditQuestionId != undefined && PostionName != undefined) {
          let target = state.questionList.find(item => {
            return item.QuestionId == auditQuestionId;
          });
          target.AccountEntryStatusDic = auditStatusArr;
          let Sort = target.Sort;
          let auditStatus = auditStatusArr.find(auditItem => {
            return auditItem.Item1 == oprQuesId;
          });
          if (showTips) {
            if (auditStatus) {
              switch (auditStatus.Item3) {
                case 1:
                  Message({
                    message: `${PostionName}提交了第${Sort}题的制单！`,
                    type: 'success',
                    center: true
                  });
                  break
                case 2:
                  Message({
                    message: `${PostionName}审核了第${Sort}题的制单！`,
                    type: 'success',
                    center: true
                  });
                  break
                case 3:
                  Message({
                    message: `${PostionName}退回了第${Sort}题的制单！`,
                    type: 'success',
                    center: true
                  });
                  break
              }
            } else {
              //没有oprQuesId 说明不是制单人制单也不是主管退回 必定是主管代|出纳签章 或者制单人保存
              if (PostionName.indexOf('出纳') > -1 || PostionName.indexOf('主管') > -1) {
                Message({
                  message: `${PostionName}审核了第${Sort}题的制单！`,
                  type: 'success',
                  center: true
                });
              }
            }
          }
        }
      }
    },
    // 模拟训练列表
    [types.SIMULATEDTRAININGLIST](state, value) {
      state.simulatedTrainingList = value;
    },

    // 模拟训练分组列表
    [types.GETEXAMPAPERGROUPLISTBYPAGE](state, value) {
      // console.log(value)
      state.getExamPaperGroupListByPage = value;
    },
    // 获取考试岗位列表
    [types.GETEXAMPAPERPOSITIONS](state, value) {
      state.getExamPaperPositions = value;
    },
    //获取大数据列表
    [types.GETOBJECTLIST](state, value) {
      console.log(value);
      state.getobjectlist = value;
    },
    //查询总账
    [types.GETCERTIFICATESUMMERDATALIST](state, value) {
      state.getcertificatesummerdatalist = value.Data;
    },
    //查询科目类型获取科目列表
    [types.GETSUBJECTBYTYPE](state, value) {
      state.getsubjectbytype = value.Data;
    },
    //查询明细
    [types.GETCERTIFICATEDETAILDATALIST](state, value) {
      // console.log(value);
      state.getcertificatedetaildatalist = value.Data;
    },
    //查询科目余额
    [types.GETCERTIFICATEBALANCEDATALIST](state, value) {
      state.getcertificatebalancedatalist = value.Data;
    },
    //查询最近一次成绩
    [types.GETSTUDENTLASTGRADE](state, value) {
      state.getstudentlastgrade = value.Data;
    },
    //错题分析
    [types.GETERRORQUESTIONLIST](state, value) {
      state.GETERRORQUESTIONLIST = value.Data;
    },
    //模拟训练最近一次团队成绩
    [types.GETTEAMLASTGRADE](state, value) {
      state.GETTEAMLASTGRADE = value.Data;
    },
    //模拟训练历史团队统计
    [types.GETTEAMGRADELIST](state, value) {
      state.GETTEAMGRADELIST = value.Data;
    },
    //查询历史成绩
    [types.GETSTUDENTGRADELIST](state, value) {
      if (value.Data) {
        for (const i of value.Data) {
          i.Count = value.Count;
        }
      }
      state.getstudentgradelist = value.Data;
    },
    //获取试卷基本预览信息
    [types.EXAM_BASIC_INFO_VIEW](state, value) {
      state.examBasicInfoView = value;
    },
    //聊天记录历史记录
    [types.CHATHISTORYLIST](state, value) {
      state.chathistorylist = value.Data;
    },
    //聊天记录
    [types.CHATSTORYLIST](state, value) {
      state.chatStorylist = value;
    },
    //校内赛任务列表
    [types.GETEXAMSCHOOLCOMPETITIONTASKLIST](state, value) {
      state.getexamschoolcompetitiontasklist = value;
    },
    // //保存校内赛任务
    // [types.SAVEEXAMSCHOOLCOMPETITIONTASK](state, value) {
    //   state.saveexamschoolcompetitiontask = value;
    // },
    //获取学校可用案例
    [types.GETAVAILABLECASELIST](state, value) {
      state.getavailablecaselist = value;
    },
    //删除校内赛任务
    [types.DELETEEXAMSCHOOLCOMPETITIONTASK](state, value) {
      state.deleteexamschoolcompetitiontask = value;
    },
    //发布校内赛任务
    [types.PUBLISHSCHOOLCOMPETITIONTASK](state, value) {
      state.publishschoolcompetitiontask = value;
    },
    // 教师-获取自主练习试卷列表
    [types.PAPERCENTERLISTBUPAGE](state, value) {
      state.papercenterlistbypage = value;
    },
    //清空标记
    [types.CLEAR_MARK](state, value) {
      state.questionList.map(quesItem => {
        quesItem.IsMark = false;
      });
      let {
        students,
        teachers,
        questionList
      } = state;
      let simpleState = {
        students,
        teachers,
        questionList
      };
      sessionStorage.setItem("state", JSON.stringify(simpleState));
    },
    //- 实时监控-团队
    [types.GETCOMPETITIONMONITOR](state, value) {
      // console.log(value);
      state.getcompetitionmonitor = value;
    },
    //- 实时监控-个人
    [types.GETINDIVIDUALCOMPETITIONMONITOR](state, value) {
      // console.log(value);
      state.getindividualcompetitionmonitor = value;
    },
    //总分排名
    [types.GETCOMPETITIONRANK](state, value) {
      // console.log(value);
      state.getcompetitionrank = value;
    },
    //成绩明细
    [types.GETCOMPETITIONDETAILRANK](state, value) {
      // console.log(value);
      state.getcompetitiondetailrank = value;
    },
    //总分排名-个人
    [types.GETINDIVIDUALCOMPETITIONRANK](state, value) {
      // console.log(value);
      state.getindividualcompetitionrank = value;
    },
    //成绩明细-个人
    [types.GETINDIVIDUALCOMPETITIONDETAILRANK](state, value) {
      // console.log(value);
      state.getindividualcompetitiondetailrank = value;
    },
    //新增/修改申请订单
    [types.SAVECASEAPPLY](state, value) {
      // console.log(value);
      state.savecaseapply = value;
    },
    //教师 自主分析-错题分析
    [types.PRACTICEERRORANALYSIS](state, value) {
      // console.log(value);
      state.practiceerroranalysis = value;
    },
    //获取校园赛可购买案例
    [types.GETSHOOLCOMPETITIONCASELIST](state, value) {
      // console.log(value);
      state.getshoolcompetitioncaselist = value;
    },
    //自主分析 - 个人练习分析
    [types.PRACTICEPERSONALANALYSIS](state, value) {
      // console.log(value);
      state.practicepersonalanalysis = value;
    },
    //自主分析 - 个人练习分析 - 明细
    [types.PRACTICEPERSONALDETAIL](state, value) {
      // console.log(value);
      state.practicepersonaldetail = value;
    },
    //模拟分析 - 团队练习分析
    [types.EMULATIONTEAMANALYSIS](state, value) {
      // console.log(value);
      state.emulationteamanalysis = value;
    },
    // -模拟分析 - 团队练习分析 - 明细
    [types.EMULATIONTEAMANALYSISDETAIL](state, value) {
      // console.log(value);
      state.emulationteamanalysisdetail = value;
    },
    // -模拟分析错题分析
    [types.EXAMERRORANALYSISDETAIL](state, value) {
      // console.log(value);
      state.examerroranalysisdetail = value;
    },
    //模拟分析 - 个人练习分析 - 明细
    [types.EMULATIONPERSONALANALYSISDETAIL](state, value) {
      // console.log(value);
      state.emulationpersonalanalysisdetail = value;
    },
    //模拟分析 - 个人练习分析 - 岗位信息
    [types.GETEXAMPAPERPOSTIONS](state, value) {
      // console.log(value);
      state.getexampaperpostions = value;
    },
    //模拟分析 - 个人练习分析 - 折线图
    [types.EMULATIONPERSONALANALYSIS](state, value) {
      // console.log(value);
      state.emulationpersonalanalysis = value;
    },
  },
  actions: {
    // 聊天记录历史记录
    [types.CHATHISTORYLIST](context, args) {
      login
        .getgroupmsghistory(args)
        .then(res => {
          context.commit(types.CHATHISTORYLIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 自主训练列表
    [types.SELFTRANININGLIST](context, args) {
      login
        .selfTrainingList(args)
        .then(res => {
          context.commit(types.SELFTRANININGLIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 自主训练题目列表
    [types.TOPIC_LIST](context, args) {
      login
        .topicList(args)
        .then(res => {
          //题目标记
          if (res.Data && res.Data.QuestionInfoList) {
            let questionList = res.Data.QuestionInfoList;
            let markArr = sessionStorage.getItem('markArr');
            markArr = markArr ? JSON.parse(markArr) : [];
            questionList.map(quesItem => {
              let markArrStr = quesItem.QuestionId + '|' + res.Data.ExamId;
              let target = markArr.find(markItem => {
                return markArrStr === markItem
              })
              if (target) {
                quesItem.IsMark = true;
              }
            });

          }
          //更新题目列表状态
          context.commit(types.TOPIC_LIST, res);
        })
        .catch(err => {
          if (err.Msg && err.Msg.includes('考试已结束')) {
            setTimeout(() => {
              router.go(-1);
            }, 800);
          }
        });
    },
    // 模拟训练题目信息
    [types.SIMULATED_TOPIC_INFO](context, args) {
      login
        .topicList(args)
        .then(res => {
          context.commit(types.SIMULATED_TOPIC_INFO, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 模拟训练列表
    [types.SIMULATEDTRAININGLIST](context, args) {
      login
        .simulatedTrainingList(args)
        .then(res => {
          context.commit(types.SIMULATEDTRAININGLIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 模拟训练分组列表
    [types.GETEXAMPAPERGROUPLISTBYPAGE](context, args) {
      console.log(context);
      login.getexampapergrouplistbypage(args).then(res => {
        console.log(res);
        context.commit(types.GETEXAMPAPERGROUPLISTBYPAGE, res);
      })
        .catch(err => {
          console.log(err);
        });
    },
    // 岗位列表
    [types.GETEXAMPAPERPOSITIONS](context, args) {
      console.log(args);
      login.getExamPaperPositions(args).then(res => {
        console.log("岗位列表******", res)
        context.commit(types.GETEXAMPAPERPOSITIONS, res);
        login.getexampapergrouplistbypage({
          pageIndex: 1,
          pageSize: 20,
          query: {
            examId: args.examId * 1
          }
        })
          .then(res => {
            context.commit(types.GETEXAMPAPERGROUPLISTBYPAGE, res);
          })
          .catch(err => {
            console.log(err);
          });
      })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取大数据列表
    [types.GETOBJECTLIST](context, args) {
      login
        .getobjectlist(args)
        .then(res => {
          context.commit(types.GETOBJECTLIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询总账
    [types.GETCERTIFICATESUMMERDATALIST](context, args) {
      login
        .getcertificatesummerdatalist(args)
        .then(res => {
          context.commit(types.GETCERTIFICATESUMMERDATALIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询科目类型获取科目列表
    [types.GETSUBJECTBYTYPE](context, args) {
      login
        .getsubjectbytype(args)
        .then(res => {
          context.commit(types.GETSUBJECTBYTYPE, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询明细
    [types.GETCERTIFICATEDETAILDATALIST](context, args) {
      login
        .getcertificatedetaildatalist(args)
        .then(res => {
          context.commit(types.GETCERTIFICATEDETAILDATALIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询科目余额
    [types.GETCERTIFICATEBALANCEDATALIST](context, args) {
      login
        .getcertificatebalancedatalist(args)
        .then(res => {
          context.commit(types.GETCERTIFICATEBALANCEDATALIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询最近一次考试成绩
    [types.GETSTUDENTLASTGRADE](context, args) {
      login
        .getstudentlastgrade(args)
        .then(res => {
          context.commit(types.GETSTUDENTLASTGRADE, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 错题分析
    [types.GETERRORQUESTIONLIST](context, args) {
      login
        .geterrorquestionlist(args)
        .then(res => {
          context.commit(types.GETERRORQUESTIONLIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //模拟训练最近一次团队成绩
    [types.GETTEAMLASTGRADE](context, args) {
      login
        .getteamlastgrade(args)
        .then(res => {
          context.commit(types.GETTEAMLASTGRADE, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //模拟训练历史团队统计
    [types.GETTEAMGRADELIST](context, args) {
      login
        .getteamgradelist(args)
        .then(res => {
          context.commit(types.GETTEAMGRADELIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询历史成绩
    [types.GETSTUDENTGRADELIST](context, args) {
      login
        .getstudentgradelist(args)
        .then(res => {
          context.commit(types.GETSTUDENTGRADELIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取试卷基本信息_预览
    [types.EXAM_BASIC_INFO_VIEW](context, args) {
      login
        .examBasicInfoView(args)
        .then(res => {
          context.commit(types.EXAM_BASIC_INFO_VIEW, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //校内赛任务列表
    [types.GETEXAMSCHOOLCOMPETITIONTASKLIST](context, args) {
      login
        .getexamschoolcompetitiontasklist(args)
        .then(res => {
          // console.log(res);
          context.commit(types.GETEXAMSCHOOLCOMPETITIONTASKLIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取学校可用案例
    [types.GETAVAILABLECASELIST](context, args) {
      login
        .getavailablecaselist(args)
        .then(res => {
          // console.log(res,'案例');
          context.commit(types.GETAVAILABLECASELIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //删除校内赛任务
    [types.DELETEEXAMSCHOOLCOMPETITIONTASK](context, args) {
      // console.log(args);
      login
        .deleteexamschoolcompetitiontask(args)
        .then(res => {
          // console.log(res);
          context.commit(types.DELETEEXAMSCHOOLCOMPETITIONTASK, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //发布校内赛任务
    [types.PUBLISHSCHOOLCOMPETITIONTASK](context, args) {
      // console.log(args);
      login
        .publishschoolcompetitiontask(args)
        .then(res => {
          // console.log(res);
          context.commit(types.PUBLISHSCHOOLCOMPETITIONTASK, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //教师-获取自主练习试卷列表
    [types.PAPERCENTERLISTBUPAGE](context, args) {
      login
        .papercenterlistbypage(args)
        .then(res => {
          context.commit(types.PAPERCENTERLISTBUPAGE, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 实时监控-团队
    [types.GETCOMPETITIONMONITOR](context, args) {
      console.log(args);
      login
        .getcompetitionmonitor(args)
        .then(res => {
          console.log(res);
          context.commit(types.GETCOMPETITIONMONITOR, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 实时监控-个人
    [types.GETINDIVIDUALCOMPETITIONMONITOR](context, args) {
      console.log(args);
      login
        .getindividualcompetitionmonitor(args)
        .then(res => {
          console.log(res);
          context.commit(types.GETINDIVIDUALCOMPETITIONMONITOR, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //总分排名
    [types.GETCOMPETITIONRANK](context, args) {
      // console.log(args);
      login
        .getcompetitionrank(args)
        .then(res => {
          // console.log(res,457);
          context.commit(types.GETCOMPETITIONRANK, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //成绩明细
    [types.GETCOMPETITIONDETAILRANK](context, args) {
      // console.log(args);
      login
        .getcompetitiondetailrank(args)
        .then(res => {
          // console.log(res);
          context.commit(types.GETCOMPETITIONDETAILRANK, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //总分排名-个人
    [types.GETINDIVIDUALCOMPETITIONRANK](context, args) {
      // console.log(args);
      login
        .getindividualcompetitionrank(args)
        .then(res => {
          // console.log(res,457);
          context.commit(types.GETINDIVIDUALCOMPETITIONRANK, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //成绩明细-个人
    [types.GETINDIVIDUALCOMPETITIONDETAILRANK](context, args) {
      // console.log(args);
      login
        .getindividualcompetitiondetailrank(args)
        .then(res => {
          // console.log(res);
          context.commit(types.GETINDIVIDUALCOMPETITIONDETAILRANK, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //新增/修改申请订单
    [types.SAVECASEAPPLY](context, args) {
      // console.log(args);
      login
        .savecaseapply(args)
        .then(res => {
          // console.log(res);
          context.commit(types.SAVECASEAPPLY, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //教师 自主分析-错题分析
    [types.PRACTICEERRORANALYSIS](context, args) {
      // console.log(args);
      login
        .practiceerroranalysis(args)
        .then(res => {
          // console.log(res);
          context.commit(types.PRACTICEERRORANALYSIS, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取校园赛可购买案例
    [types.GETSHOOLCOMPETITIONCASELIST](context, args) {
      // console.log(args);
      login
        .getshoolcompetitioncaselist(args)
        .then(res => {
          // console.log(res);
          context.commit(types.GETSHOOLCOMPETITIONCASELIST, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //自主分析 - 个人练习分析
    [types.PRACTICEPERSONALANALYSIS](context, args) {
      // console.log(args);
      login
        .practicepersonalanalysis(args)
        .then(res => {
          // console.log(res);
          context.commit(types.PRACTICEPERSONALANALYSIS, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //自主分析 - 个人练习分析 - 明细
    [types.PRACTICEPERSONALDETAIL](context, args) {
      // console.log(args);
      login
        .practicepersonaldetail(args)
        .then(res => {
          // console.log(res);
          context.commit(types.PRACTICEPERSONALDETAIL, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //模拟分析 - 团队练习分析
    [types.EMULATIONTEAMANALYSIS](context, args) {
      // console.log(args);
      login
        .emulationteamanalysis(args)
        .then(res => {
          // console.log(res);
          context.commit(types.EMULATIONTEAMANALYSIS, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // -模拟分析 - 团队练习分析 - 明细
    [types.EMULATIONTEAMANALYSISDETAIL](context, args) {
      // console.log(args);
      login
        .emulationteamanalysisdetail(args)
        .then(res => {
          // console.log(res);
          context.commit(types.EMULATIONTEAMANALYSISDETAIL, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // -模拟分析错题分析
    [types.EXAMERRORANALYSISDETAIL](context, args) {
      // console.log(args);
      login
        .examerroranalysisdetail(args)
        .then(res => {
          // console.log(res);
          context.commit(types.EXAMERRORANALYSISDETAIL, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //模拟分析 - 个人练习分析 - 明细
    [types.EMULATIONPERSONALANALYSISDETAIL](context, args) {
      // console.log(args);
      login
        .emulationpersonalanalysisdetail(args)
        .then(res => {
          // console.log(res);
          context.commit(types.EMULATIONPERSONALANALYSISDETAIL, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //模拟分析 - 个人练习分析 - 岗位信息
    [types.GETEXAMPAPERPOSTIONS](context, args) {
      // console.log(args);
      login
        .getexampaperpostions(args)
        .then(res => {
          // console.log(res);
          context.commit(types.GETEXAMPAPERPOSTIONS, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    //模拟分析 - 个人练习分析 - 折线图
    [types.EMULATIONPERSONALANALYSIS](context, args) {
      // console.log(args);
      login
        .emulationpersonalanalysis(args)
        .then(res => {
          // console.log(res);
          context.commit(types.EMULATIONPERSONALANALYSIS, res);
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
  strict: debug
});


// WEBPACK FOOTER //
// ./src/store/index.js